<template>
  <section id="about" class="section" style="background-image: url(/images/about.jpg)">
    <div class="page">
      <div class="row">
        <div class="gap col1"/>
        <div class="col col3">
          <h2>{{$t('about.aboutUs')}}</h2>
          <p>{{$t('about.about1')}}</p>
          <p>{{$t('about.about2')}}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AboutComponent'
})
</script>
